import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import DocumentsIcon from '@mui/icons-material/FolderOpenOutlined';

import { DocumentsTableContainer } from '../../components/documents';
import StatsBox from '../../components/shared/StatsBox';

import { fetchDocuments } from '../../actions/adminActions';

import './documents-page.scss';

const DocumentsPage = (props) => {
  const { documents, countryList, fetchDocuments, currentUserId } = props;

  useEffect(() => {
    fetchDocuments();
  }, [fetchDocuments, currentUserId]);

  return (
    <div className="documents-page">
      <Grid container spacing={3} sx={{ mb: 3, display: { xs: 'none', md: 'flex' } }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <StatsBox title='Total Documents' number={documents?.length} icon={<DocumentsIcon />} />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <StatsBox title='Total Documents' number={documents?.length} icon={<DocumentsIcon />} />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <StatsBox title='Total Documents' number={documents?.length} icon={<DocumentsIcon />} />
        </Grid>
      </Grid>
      <DocumentsTableContainer
        documents={documents}
        countries={countryList}
        withButton
      />
    </div>
  );
};

DocumentsPage.propTypes = {
  documents: PropTypes.array,
  fetchDocuments: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  documents: state.documents.list,
  countryList: state.countries.list,
  currentUserId: state.user.currentUser?.uid,
});

const mapDispatchToProps = (dispatch) => ({
  fetchDocuments: () => dispatch(fetchDocuments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentsPage);
